import { Inbox } from 'lucide-react';
import React from 'react';
import { REPORTING_API_V1_EMPTY_MESSAGE } from 'src/redux/admin/reporting-api-v1/reporting-api-v1.types';

interface ReportingEmptyStateProps {
  className?: string;
  title?: string;
  message?: string;
}

const ReportingEmptyState: React.FC<ReportingEmptyStateProps> = ({
  className = '',
  title = 'No Data Available',
  message = REPORTING_API_V1_EMPTY_MESSAGE,
}) => (
  <div className={`bg-white rounded-lg shadow-md border border-gray-200 p-8 ${className}`}>
    <div className="flex flex-col items-center justify-center h-64">
      <Inbox className="w-12 h-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-600 text-center">{message}</p>
    </div>
  </div>
);

export default ReportingEmptyState;
